import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OfflineCurrentCustomerMetadata } from './offline-model';
import { RootState } from '../root/root-types';

export const OFFLINE_QUEUE_FEATURE_KEY = 'offlineQueue';

interface OfflineQueueState {
  syncing: boolean;
  error?: string;
  currentCustomer?: OfflineCurrentCustomerMetadata;
  isSynced: boolean;
}

const initialState: OfflineQueueState = {
  syncing: false,
  isSynced: false,
};

export const offlineQueueSlice = createSlice({
  name: 'offlineQueue',
  initialState,
  reducers: {
    syncStart(state) {
      state.syncing = true;
      state.error = undefined;
    },
    syncSuccess(state) {
      state.syncing = false;
      state.isSynced = true;
    },
    syncError(state, action: PayloadAction<string>) {
      state.syncing = false;
      state.error = action.payload;
      state.isSynced = false;
    },
    updateCurrentCustomer(
      state,
      action: PayloadAction<OfflineCurrentCustomerMetadata | undefined>
    ) {
      state.currentCustomer = action.payload;
    },
  },
});

export const offlineQueueReducer = offlineQueueSlice.reducer;

export const { syncStart, syncSuccess, syncError, updateCurrentCustomer } =
  offlineQueueSlice.actions;

export const getOfflineQueueState = (rootState: RootState): OfflineQueueState =>
  rootState[OFFLINE_QUEUE_FEATURE_KEY];

export const getCurrentCustomer = createSelector(
  getOfflineQueueState,
  (state) => state.currentCustomer
);

export const getSyncingStatus = createSelector(
  getOfflineQueueState,
  (state) => state.syncing
);

export const getSyncError = createSelector(
  getOfflineQueueState,
  (state) => state.error
);

export const getIsSynced = createSelector(
  getOfflineQueueState,
  (state) => state.isSynced
);
